import PropTypes from 'prop-types';
import React from "react";
import { startCase } from "lodash/string"
import { injectIntl, defineMessages } from "react-intl"
import listMessages from "../../messages/lists"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

const messages = defineMessages({
  addFilter: {
    id: "filter.add-filter",
    defaultMessage: "Add Filter"
  }
})

export const AddFilter = ({ onChange, label, options, intl }) => {
  label = intl.formatMessage(messages.addFilter)
  return (
    <div className="c-results-filters__footer__inner" 
         style={getStyles('c-results-filters__footer__inner')}>
      {getStyleTag('c-results-filters__footer__inner')}
      <select value="" onChange={onChange} 
              style={getStyles([
                'c-results__select', 
                'c-results-filters__footer__select'
              ])}>
        <option value="" defaultValue>
          {label}
        </option>
        {options.map((option, i) => (
          <option key={i} value={option.name}>
            {option.id in listMessages
              ? intl.formatMessage(listMessages[option.id])
              : option.label || startCase(option.name)}
          </option>
        ))}
      </select>
    </div>
  )
}

AddFilter.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string
    })
  )
}

export default injectIntl(AddFilter)



// WEBPACK FOOTER //
// ./webapp/components/elements/AddFilter.js